import { FC, ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ProfileButton } from '../../components';
import {
	Apartment,
	BrandingWatermark,
	CalendarToday,
	Dashboard,
	FormatListBulleted,
	Message,
	People,
	Store,
	Storefront,
	SwapHoriz,
	TimeToLeave,
} from '@mui/icons-material';
import { ContainerCollapsed, PageContent, ProfileAside, ProfilePages, ToggleButton } from './Registration.styles';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';

interface RegistrationProps {
	children?: ReactNode;
}

const Registration: FC<RegistrationProps> = ({ children }) => {
	const location = useLocation();
	const [collapsed, setCollapsed] = useState(false);

	const subPages = [
		{
			name: 'Resumo',
			path: '/cadastros',
			icon: <Dashboard fontSize='inherit' />,
		},
		{
			name: 'Usuários',
			path: '/cadastros/usuarios',
			icon: <People fontSize='inherit' />,
		},
		{
			name: 'Lojistas',
			path: '/cadastros/lojistas',
			icon: <Storefront fontSize='inherit' />,
		},
		{
			name: 'Grupos de Concessionárias',
			path: '/cadastros/grupo-concessionarias',
			icon: <Apartment fontSize='inherit' />,
		},
		{
			name: 'Concessionárias',
			path: '/cadastros/concessionarias',
			icon: <Store fontSize='inherit' />,
		},
		{
			name: 'Concessionária x Revenda',
			path: '/cadastros/concessionaria-revenda',
			icon: <SwapHoriz fontSize='inherit' />,
		},
		{
			name: 'Texto Padrão',
			path: '/cadastros/texto-padrao',
			icon: <Storefront fontSize='inherit' />,
		},
		{
			name: 'Veículos - Marcas',
			path: '/cadastros/veiculos-marcas',
			icon: <BrandingWatermark fontSize='inherit' />,
		},
		{
			name: 'Veículos - Modelos',
			path: '/cadastros/veiculos-modelos',
			icon: <TimeToLeave fontSize='inherit' />,
		},
		{
			name: 'Veículos - Anos',
			path: '/cadastros/veiculos-anos',
			icon: <CalendarToday fontSize='inherit' />,
		},
		{
			name: 'Veículos - Acessórios',
			path: '/cadastros/veiculos-acessorios',
			icon: <FormatListBulleted fontSize='inherit' />,
		},
		{
			name: 'Envio de Push e E-mails',
			path: '/cadastros/envio-push-email',
			icon: <Message fontSize='inherit' />,
		},
	];

	return (
		<ContainerCollapsed collapsed={collapsed}>
			<ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
				{collapsed ? <FormatIndentIncreaseIcon style={{position:"relative", top:"1px"}} /> : <FormatIndentDecreaseIcon style={{position:"relative", top:"1px"}} />} 
			</ToggleButton>
			
			<ProfileAside collapsed={collapsed}>
				{!collapsed &&
				<>
				<ProfilePages>
					{subPages.map((page) => (
						<Link style={{ width: '100%' }} to={page.path} key={page.name}>
							<ProfileButton
								label={page.name}
								icon={page.icon}
								active={location.pathname.split('/')[2] === page.path.split('/')[2]}
							/>
						</Link>
					))}
				</ProfilePages>
				</>
				}
			</ProfileAside>
			<PageContent collapsed={collapsed}>{children}</PageContent>
		</ContainerCollapsed>
	);
};

export default Registration;
